import React, { useState } from 'react';
import StoreRequestPopup from './StoreRequestPopup';
import './LaunchStore.css';
import { MdCheckCircle, MdCreditCard, MdInventory } from 'react-icons/md';
import { FiArrowRight, FiMessageCircle } from 'react-icons/fi';
import { FaRocket } from 'react-icons/fa';

const LaunchStore = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleGetStartedClick = () => {
    setIsPopupOpen(true);
  };

  const handleDemoClick = (e) => {
    e.preventDefault();
    window.open('https://demo-site.creativepulse.pk/', '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <section className="launchstore-section">
        <div className="launchstore-container">
          <div className="launchstore-card">
            {/* Background elements */}
            <div className="launchstore-bg-primary"></div>
            <div className="launchstore-bg-gradient"></div>
            <div className="launchstore-bg-mesh"></div>
            <div className="launchstore-grid-pattern"></div>

            {/* Floating elements */}
            <div className="floating-card floating-card-1">
              <div className="floating-card-inner">
                <div className="floating-icon-bg">
                  <MdInventory className="floating-icon" />
                </div>
                <p className="floating-title">Linen Set</p>
                <p className="floating-price">PKR 4,890</p>
              </div>
            </div>

            <div className="floating-card floating-card-2">
              <div className="floating-order">
                <div className="order-check">
                  <MdCheckCircle className="check-icon" />
                  <span>Order Confirmed</span>
                </div>
                <p className="order-id">#ATL-2384 · COD</p>
                <p className="order-amount">PKR 12,390</p>
              </div>
            </div>

            {/* Main Content */}
            <div className="launchstore-content">
              <div className="launchstore-badge">
                <FaRocket className="badge-icon" />
                <span>Your Turn</span>
              </div>

              <h2 className="launchstore-title">
                Ready to Launch Your <br className="title-break" />
                <span className="title-gradient">Online Store?</span>
              </h2>

              <p className="launchstore-description">
                Start with the standard package, explore the demo store, and see how your business can start selling through its own branded website.
              </p>

              <div className="launchstore-buttons">
                <a
                  href="#"
                  className="btn-demo"
                  onClick={handleDemoClick}
                >
                  View Demo Store
                  <FiArrowRight className="btn-icon" />
                </a>
                <button
                  className="btn-getstarted"
                  onClick={handleGetStartedClick}
                >
                  Get Started
                </button>
              </div>

              <p className="launchstore-note">
                Affordable setup · Monthly subscription · Add-ons when you need more.
              </p>

              <div className="floating-whatsapp floating-card-3">
                <div className="whatsapp-badge">
                  <span className="whatsapp-icon">
                    <FiMessageCircle />
                  </span>
                  <span>New WhatsApp inquiry</span>
                </div>
              </div>

              <div className="floating-payment floating-card-4">
                <div className="payment-badge">
                  <span className="payment-icon">
                    <MdCreditCard />
                  </span>
                  <span>Payment received</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Store Request Popup */}
      <StoreRequestPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
};

export default LaunchStore;